import { useQuery } from "@tanstack/react-query";
import * as Api from "./documents";

export function useGetDocuments(bookingNumber: number) {
  return useQuery({
    queryKey: ['documents', bookingNumber],
    queryFn: ({signal}) => Api.getDocuments(bookingNumber, signal),
  })
}
